/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react';

const ContactConfirmationModal = (props) => {

    // referencias a los elementos que me interesa monitorear
    const containerRef = useRef(null);
    const closeRef = useRef(null);

    // cerrar si el click fue afuera del contenedor o en la x
    const handleClose = (e) => {
        if (props.onClose && (!containerRef.current.contains(e.target) || closeRef.current.contains(e.target))) {
            props.onClose(false);
        }
    };

    // habilitar y deshabilitar scroll
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = null;
        }
    }, [])

    return (
        <section className="contact-confirmation-modal">
            <div className="modal show" onClick={handleClose}>
                <div ref={containerRef} className="modal-box large">
                    <div className="modal-header">
                        <span className="modal-close" ref={closeRef} onClick={handleClose}>✕</span>
                    </div>
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="contact-confirmation-container">
                                <img src={`${window._env_.STATIC_HOST}/static/kinto/img/cotizador/message-sended.svg`} alt="Mensaje enviado"></img>
                                <h3 className="title3">Muchas gracias por su consulta</h3>
                                <div className="title4">
                                    <strong>Nuestro comercial se pondrá en contacto en la brevedad</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactConfirmationModal;